import { SB } from '@play-co/replicant';

export const eventState = SB.object({
  // Number of times user has played this tournament event
  plays: SB.int(),
  // User's best score for this tournament event
  highScore: SB.int(),
  // When user has achieved the high score
  highScoreAt: SB.int(),
  // Timestamp of the last time user has played this tournament event
  lastPlayedAt: SB.int(),
  // Last score user has achieved, will only be defined if user has milestone rewards to claim.
  lastScore: SB.int().optional(),
  // Check if user has claimed the tournament rewards, which are different from milestone rewards.
  claimed: SB.boolean().optional(),
});

export const airplaneTournamentSchema = {
  // Current airplane tournament session.
  session: SB.object({
    continues: SB.int(),
    eventId: SB.string(),
  }).optional(),

  // Tournament events by id
  events: SB.map(eventState).optional(),

  // Timestamp of the last time user has seen the tournament popup
  autoPresentedAt: SB.int().optional(),
};
